import React, { HTMLAttributes } from 'react';

import styles from './InsuranceIframe.module.scss';

const InsuranceIframe = (props: HTMLAttributes<HTMLIFrameElement> & { srcDoc?: string }) => {
  return (
    <div className="flex">
      <iframe
        className={`${styles['insurance-iframe']} none block-up-m flex-1`}
        title="insurance-iframe"
        {...props}
        src={
          process.env.NEXT_STATIC_INSURANCE_URL ||
          'https://pacifica-production.agreo.fr/ASPNET/specific/pacifica/?pleinchamp=1&wscheck=0'
        }
      />
    </div>
  );
};

export default InsuranceIframe;
